import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { EntityProfileType } from "@common/types/entity";
import { entityTypeV2Labels } from "@common/constants/entity";
import { ClientDetailsRow } from "../clientViewConfig";
import { EMPTY_CELL_VALUE } from "./lib";

export const LegalTypeCell = ({
    row,
}: CellContext<
    ViewTableFeatures,
    ClientDetailsRow,
    EntityProfileType | null
>) => {
    if (row.original.type === "workspace") {
        return EMPTY_CELL_VALUE;
    }

    const legalType = row.original.legalType;

    if (!legalType) {
        return EMPTY_CELL_VALUE;
    }

    return <span>{entityTypeV2Labels[legalType]}</span>;
};
